import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class ReceivingData {
  /* 收货数据列表 */
  static getReceivingDataList(options) {
    let url = `/zwy/api/receipt/data/list?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 订单导入
  static postExcel(data) {
    const url = `/zwy/api/upload/receipt/data`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default ReceivingData;
